module.exports = __webpack_public_path__ + "static/media/IMG_1368.d6b0d1b3.JPG";